<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      card: null
    };
  },
  methods: {
    getCard() {
      api.get("plans/card").then((response) => {
        this.card = response.data.card;
      });
    },
  },
  mounted() {
    this.getCard()
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meu Cartão</h3>
        <p></p>
      </div>
    </div>

    <div class="text-center" v-if="!card">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div class="d-flex justify-content-center">
      <img v-if="card" class="rounded-lg w-100" style="max-width: 500px;" :src="'data:image/jpeg;base64,' + card" />
    </div>
  </Layout>
</template>
